import { DropdownButton, DropdownButtonType } from '@tableau/widgets';
import React from 'react';

import { getAppStore } from '~src/app/AppStore';
import { siteUrlsSelector } from '~src/app/selectors/SiteUrlsSelectors';
import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { LineageRelationshipType, RelatedContentType } from '~src/ts/models/ContentLineageRelationshipInfo';

import { LinkedTaskItemSelectorContent, LinkedTaskItemSelectorContentProps } from './LinkedTaskItemSelectorContent';

const rootClass: string = 'LinkedTaskItemSelector';
export const linkedTaskItemSelectorDropdownId = rootClass + 'Id';

const LinkedTaskItemSelectorDropdown = cssClass(rootClass, 'Dropdown', {
  flex: '1 1 auto'
});

export type LinkedTaskItemSelectorProps = {
  index: number;
  id: string;
  selectedItemId?: string;
  selectedItemName?: string;
  contentType: RelatedContentType;
  lineageRelationshipType: LineageRelationshipType;
}

export function LinkedTaskItemSelector(props: LinkedTaskItemSelectorProps): JSX.Element {
  const [closeDropdown] = React.useState<{done: () => void}>({done: null});
  const onClose = React.useCallback(() => {
    closeDropdown.done();
  }, [closeDropdown]);

  const siteUrls = siteUrlsSelector(getAppStore().getState());

  const itemProps: LinkedTaskItemSelectorContentProps = {
    index: props.index,
    id: props.id,
    contentType: props.contentType,
    lineageRelationshipType: props.lineageRelationshipType,
    siteUrls: siteUrls,
    selectedItemId: props.selectedItemId,
    closeDialog: onClose,
  };

  const dropdownId = `${linkedTaskItemSelectorDropdownId}${props.id}`;
  const assignDoneFunction = (done: () => void) => { closeDropdown.done = done; };

  return (
    <div className={LinkedTaskItemSelectorDropdown}>
      <DropdownButton
        label={undefined}
        aria-controls={dropdownId}
        aria-haspopup={'dialog'}
        closeOnPopupBlur={true}
        onOpen={assignDoneFunction}
        popupContent={
          <div role='dialog' id={dropdownId}>
            {<LinkedTaskItemSelectorContent {...itemProps} />}
          </div>
        }
        testId={'LinkedTaskItemSelectorDropdownButton'}
        type={DropdownButtonType.Outline}
      >
        {props.selectedItemName || Messages.linkedTasksSelectFlow()}
      </DropdownButton>
    </div>
  );
}


